var _rect, _rect2, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPublicWifi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 11.5,
    fill: "url(#paint0_linear_18_2036)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "url(#paint1_linear_18_2036)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2036",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 25,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 11.25H12V36.25H37V11.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7287 19.9686L26.51 14.1977C25.3954 13.3019 23.5933 13.3019 22.4891 14.1873L15.2704 19.9686C14.4579 20.6144 13.9371 21.9789 14.1142 22.9998L15.4996 31.2914C15.7496 32.7706 17.1663 33.9685 18.6663 33.9685H30.3329C31.8225 33.9685 33.2496 32.7602 33.4996 31.2914L34.885 22.9998C35.0516 21.9789 34.5308 20.6144 33.7287 19.9686ZM25.2391 29.1665C25.0308 29.3747 24.7704 29.4789 24.4996 29.4789C24.2287 29.4789 23.9683 29.3748 23.76 29.1768C23.3537 28.7706 23.3537 28.1143 23.76 27.7081C24.1662 27.3018 24.8329 27.3018 25.2391 27.7081C25.6454 28.1039 25.6454 28.7602 25.2391 29.1665ZM27.2704 26.7706C27.1141 26.9268 26.9162 27.0102 26.7079 27.0102C26.51 27.0102 26.3225 26.9372 26.1662 26.7914C25.1558 25.8227 23.8433 25.8227 22.8225 26.7914C22.51 27.0935 22.0204 27.0831 21.7183 26.7706C21.4163 26.4581 21.4267 25.9685 21.7392 25.6664C23.3537 24.1143 25.6141 24.1143 27.2391 25.6664C27.5621 25.9581 27.5725 26.4581 27.2704 26.7706ZM29.4787 24.5623C29.3225 24.7185 29.1246 24.8018 28.9162 24.8018C28.7183 24.8018 28.5204 24.7289 28.3746 24.5831C27.885 24.1039 27.3329 23.7185 26.7496 23.4372C25.2912 22.7393 23.6975 22.7393 22.2496 23.4372C21.6663 23.7185 21.1246 24.1039 20.6246 24.5831C20.3225 24.8852 19.8225 24.8852 19.5204 24.5727C19.2183 24.2602 19.2288 23.7706 19.5308 23.4685C20.1454 22.8643 20.8329 22.3852 21.5725 22.031C23.4579 21.1248 25.5412 21.1248 27.4162 22.031C28.1558 22.3852 28.8433 22.8643 29.4579 23.4685C29.7704 23.7602 29.7808 24.2602 29.4787 24.5623Z",
    fill: "#34D399"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2036",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2036",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublicWifi);
export default __webpack_public_path__ + "static/media/icon-public-wifi.609072c681a605f5077fe36426101023.svg";
export { ForwardRef as ReactComponent };